import { TBaseSVG } from "../../models";

import { theme } from "..";

export default ({ title, color, className, onClick }: TBaseSVG) => (
    <svg
        onClick={onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={className || "icon-arrow-diagonal"}
    >
        <title>{title}</title>
        <path
            d="M18.3638 5.63725L5.63589 18.3652M18.3638 15.5367V5.63725V15.5367ZM18.3638 5.63725H8.46432H18.3638Z"
            stroke={color || theme.purple600}
            strokeWidth="1.2"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
